(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function(){
  function init(wrap){
    if(wrap.dataset.jjHdrInit) return;
    wrap.dataset.jjHdrInit='1';

    var sectionId = wrap.id.replace('jjhdr-','');
    var drawer    = document.getElementById('jjhdr-drawer-'+sectionId);
    var hamburger = wrap.querySelector('.jjhdr-hamburger');
    var closeBtn  = drawer ? drawer.querySelector('.jjhdr-drawer-close') : null;
    var backdrop  = drawer ? drawer.querySelector('.jjhdr-drawer-backdrop') : null;

    if(!drawer) return;

    function openDrawer(){
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden','false');
      hamburger.setAttribute('aria-expanded','true');
      document.body.style.overflow='hidden';
      if(closeBtn) closeBtn.focus();
    }
    function closeDrawer(){
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden','true');
      hamburger.setAttribute('aria-expanded','false');
      document.body.style.overflow='';
      hamburger.focus();
    }

    if(hamburger) hamburger.addEventListener('click', openDrawer);
    if(closeBtn)  closeBtn.addEventListener('click', closeDrawer);
    if(backdrop)  backdrop.addEventListener('click', closeDrawer);

    drawer.addEventListener('keydown', function(e){
      if(e.key==='Escape') closeDrawer();
    });
  }

  function initAll(){
    document.querySelectorAll('[id^="jjhdr-"]').forEach(function(el){
      if(el.id.indexOf('jjhdr-drawer')===-1) init(el);
    });
  }

  if(document.readyState!=='loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('[id^="jjhdr-"]');
    if(el && el.id.indexOf('jjhdr-drawer')===-1) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-cart"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  function init(root){
    if(root.dataset.crtInit) return;
    root.dataset.crtInit = '1';

    root.querySelectorAll('.jjcrt-qty-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var key = btn.dataset.key;
        var input = root.querySelector('.jjcrt-qty-input[data-key="' + key + '"]');
        if(!input) return;
        var val = parseInt(input.value, 10) || 0;
        if(btn.dataset.action === 'inc') val = Math.min(val + 1, 99);
        if(btn.dataset.action === 'dec') val = Math.max(val - 1, 0);
        input.value = val;
        /* auto-submit after short debounce */
        clearTimeout(input._t);
        input._t = setTimeout(function(){
          var form = document.getElementById('jjcrt-form');
          if(form) form.submit();
        }, 600);
      });
    });
  }
  function initAll(){ document.querySelectorAll('.jjcrt').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function(e){ var el = e.target.querySelector('.jjcrt'); if(el) init(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-catalog"] && !Shopify.designMode) return;
  try {
    
(function(){
  var sid      = '{{ section.id }}';
  var cover    = document.getElementById('jjcat-cover-'  + sid);
  var shareBtn = document.getElementById('jjcat-share-'  + sid);

  /* fade out cover after a short delay so the PDF has time to paint */
  if(cover){ setTimeout(function(){ cover.classList.add('hidden'); }, 1800); }

  /* share button — Web Share API with clipboard fallback */
  if(shareBtn){
    shareBtn.addEventListener('click', function(){
      var label = shareBtn.querySelector('.jjcat-share-label');
      var url   = window.location.href;
      if(navigator.share){
        navigator.share({ title: document.title, url: url }).catch(function(){});
      } else {
        navigator.clipboard.writeText(url).then(function(){
          if(label){ label.textContent = 'Link copied!'; }
          shareBtn.classList.add('copied');
          setTimeout(function(){
            if(label){ label.textContent = '{{ section.settings.share_label | default: "Share" | escape }}'; }
            shareBtn.classList.remove('copied');
          }, 2200);
        }).catch(function(){});
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
  function cap(s){return s.charAt(0).toUpperCase()+s.slice(1);}

  function init(root){
    if(root.dataset.jjCollInit) return;
    root.dataset.jjCollInit='1';

    var grid     = root.querySelector('.jjcoll-grid');
    var subEl    = root.querySelector('.jjcoll-sub');
    var cards    = Array.prototype.slice.call(root.querySelectorAll('.jjcoll-card'));
    if(!grid||!cards.length) return;

    var featured = parseInt(root.dataset.featured,10)||2;
    var state    = { mood:'none', maxAge:99, group:'all' };

    /* section wrapper for full-bleed bg tint */
    var sid = root.id.replace('jjcoll-','');
    var pageSection = document.getElementById('shopify-section-'+sid);

    /* ── mood sort ── */
    function ordered(mode){
      return cards.slice().sort(function(a,b){
        var d=(+b.dataset[mode])-(+a.dataset[mode]);
        return d!==0?d:(+a.dataset.idx)-(+b.dataset.idx);
      });
    }

    function applyMood(mode,instant){
      var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      var first=cards.map(function(c){return c.getBoundingClientRect();});

      root.classList.remove('m-calm','m-bright','m-wow');
      if(mode!=='none') root.classList.add('m-'+mode);

      /* button states */
      root.querySelectorAll('.jjcoll-mode').forEach(function(b){
        b.setAttribute('aria-pressed',b.dataset.mode===mode?'true':'false');
      });

      /* subline */
      if(subEl){
        subEl.textContent=subEl.dataset[mode]||'';
        subEl.classList.toggle('show',mode!=='none');
      }

      /* full-section bg tint */
      if(pageSection){
        var bgMap={calm:root.dataset.bgCalm,bright:root.dataset.bgBright,wow:root.dataset.bgWow};
        pageSection.style.background=mode!=='none'?(bgMap[mode]||''):'';
      }

      /* reorder + featured why text */
      var ord=ordered(mode!=='none'?mode:'calm');
      ord.forEach(function(c){grid.appendChild(c);});
      cards.forEach(function(c){
        c.classList.remove('feat');
        var w=c.querySelector('.jjcoll-why');if(w){w.textContent='';w.hidden=true;}
      });
      if(mode!=='none'){
        ord.slice(0,featured).forEach(function(c){
          c.classList.add('feat');
          var t=c.dataset['why'+cap(mode)]||'';
          var w=c.querySelector('.jjcoll-why');
          if(t&&w){w.textContent=t;w.hidden=false;}
        });
      }

      applyVisibility();
      if(instant||reduce) return;

      /* FLIP animation */
      cards.forEach(function(c,i){
        var f=first[i],l=c.getBoundingClientRect();
        var dx=f.left-l.left,dy=f.top-l.top;
        var sx=l.width?f.width/l.width:1,sy=l.height?f.height/l.height:1;
        var inn=c.querySelector('.jjcoll-card-in');
        c.style.transition='none';inn.style.transition='none';
        c.style.transformOrigin='top left';inn.style.transformOrigin='top left';
        c.style.transform='translate('+dx+'px,'+dy+'px) scale('+sx+','+sy+')';
        inn.style.transform='scale('+(1/sx)+','+(1/sy)+')';
      });
      requestAnimationFrame(function(){requestAnimationFrame(function(){
        cards.forEach(function(c){
          var inn=c.querySelector('.jjcoll-card-in');
          c.style.transition='transform .6s cubic-bezier(.2,.85,.25,1)';
          inn.style.transition='transform .6s cubic-bezier(.2,.85,.25,1)';
          c.style.transform='';inn.style.transform='';
        });
      });});
    }

    /* ── age + group filter ── */
    function applyVisibility(){
      cards.forEach(function(c){
        var minAge  = parseInt(c.dataset.minAge   || 0, 10);
        var maxGrp  = parseInt(c.dataset.maxGroup || 4, 10);
        var ageHide = state.maxAge !== 99 && minAge > state.maxAge;
        var grpHide = (state.group === 'home'  && maxGrp > 4)
                   || (state.group === 'party' && maxGrp <= 4);
        c.hidden = ageHide || grpHide;
      });
    }

    /* ── mood buttons ── */
    root.querySelectorAll('.jjcoll-mode').forEach(function(b){
      b.addEventListener('click',function(){
        state.mood=b.dataset.mode;
        applyMood(state.mood);
      });
    });

    /* ── age buttons ── */
    root.querySelectorAll('.jjcoll-age').forEach(function(b){
      b.addEventListener('click',function(){
        root.querySelectorAll('.jjcoll-age').forEach(function(x){
          x.classList.remove('is-active');x.setAttribute('aria-pressed','false');
        });
        b.classList.add('is-active');b.setAttribute('aria-pressed','true');
        state.maxAge=parseInt(b.dataset.maxAge,10)||99;
        applyVisibility();
      });
    });

    /* ── group buttons ── */
    root.querySelectorAll('.jjcoll-group').forEach(function(b){
      b.addEventListener('click',function(){
        root.querySelectorAll('.jjcoll-group').forEach(function(x){
          x.classList.remove('is-active');x.setAttribute('aria-pressed','false');
        });
        b.classList.add('is-active');b.setAttribute('aria-pressed','true');
        state.group=b.dataset.group;
        applyVisibility();
      });
    });

    /* ── mood info tooltip ── */
    var infoBtn=root.querySelector('.jjcoll-moodinfo-btn');
    var infoTip=root.querySelector('.jjcoll-moodinfo-tip');
    if(infoBtn&&infoTip){
      infoBtn.addEventListener('click',function(e){
        e.stopPropagation();
        var open=infoTip.hidden;
        infoTip.hidden=!open;
        infoBtn.setAttribute('aria-expanded',open?'true':'false');
      });
      document.addEventListener('click',function(){
        infoTip.hidden=true;
        infoBtn.setAttribute('aria-expanded','false');
      });
    }

    /* ── init ── */
    var def=root.dataset.default;
    if(def&&def!=='none') applyMood(def,true);
    else applyVisibility();
  }

  function initAll(){document.querySelectorAll('.jjcoll').forEach(init);}
  if(document.readyState!=='loading') initAll();
  else document.addEventListener('DOMContentLoaded',initAll);
  document.addEventListener('shopify:section:load',function(e){
    var el=e.target.querySelector('.jjcoll');if(el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-demo-videos"] && !Shopify.designMode) return;
  try {
    
(function(){

  function init(root){
    if(root.dataset.jjDvInit) return;
    root.dataset.jjDvInit='1';

    var sid    = root.id.replace('jjdv-','');
    var dialog = document.getElementById('jjdv-dialog-'+sid);
    var player = dialog ? dialog.querySelector('.jjdv-dialog-player') : null;
    var closeBtn = dialog ? dialog.querySelector('.jjdv-dialog-close') : null;

    /* ── Filter ── */
    var filterBtns = Array.from(root.querySelectorAll('.jjdv-filter'));
    var cards      = Array.from(root.querySelectorAll('.jjdv-card'));

    filterBtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        var filter = btn.dataset.filter;
        filterBtns.forEach(function(b){ b.classList.toggle('is-active', b===btn); });
        cards.forEach(function(card){
          var show = filter==='all' || card.dataset.cat===filter;
          card.classList.toggle('is-hidden', !show);
        });
      });
    });

    /* ── Video lightbox ── */
    function openVideo(ytId, title){
      if(!dialog||!ytId) return;
      player.innerHTML='<iframe src="https://www.youtube.com/embed/'+ytId+'?autoplay=1&rel=0" allow="autoplay; fullscreen" allowfullscreen title="'+title+'"></iframe>';
      dialog.showModal();
      if(closeBtn) closeBtn.focus();
    }
    function closeVideo(){
      if(!dialog) return;
      dialog.close();
      if(player) player.innerHTML='';
    }

    root.querySelectorAll('.jjdv-thumb-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        openVideo(btn.dataset.ytid, btn.dataset.title||'');
      });
    });

    if(closeBtn) closeBtn.addEventListener('click', closeVideo);
    if(dialog){
      dialog.addEventListener('click', function(e){ if(e.target===dialog) closeVideo(); });
      dialog.addEventListener('cancel', closeVideo);
    }
  }

  function initAll(){
    document.querySelectorAll('[id^="jjdv-"]').forEach(function(el){
      if(el.classList.contains('jjdv')) init(el);
    });
  }

  if(document.readyState!=='loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('.jjdv');
    if(el) init(el);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-find-a-store"] && !Shopify.designMode) return;
  try {
    
(function(){
  var GEO_URL = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&addressdetails=0&countrycodes=us';
  var LEAFLET_CSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  var LEAFLET_JS  = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';

  /* ── geocoding ── */
  function geocode(q, done) {
    if (!q || !q.trim()) { done(null); return; }
    var key = 'jjfas2:' + q.trim().toLowerCase();
    try { var c = sessionStorage.getItem(key); if (c) { done(JSON.parse(c)); return; } } catch(e){}
    fetch(GEO_URL + '&q=' + encodeURIComponent(q))
      .then(function(r){ return r.json(); })
      .then(function(d){
        var pos = d && d[0] ? { lat: +d[0].lat, lng: +d[0].lon } : null;
        try { if (pos) sessionStorage.setItem(key, JSON.stringify(pos)); } catch(e){}
        done(pos);
      })
      .catch(function(){ done(null); });
  }

  function geocodeSequential(addrs, onEach, onDone) {
    var i = 0;
    function next() {
      if (i >= addrs.length) { onDone(); return; }
      var idx = i++;
      var cached = false;
      try { cached = !!sessionStorage.getItem('jjfas2:' + addrs[idx].trim().toLowerCase()); } catch(e){}
      geocode(addrs[idx], function(pos) {
        onEach(idx, pos);
        setTimeout(next, cached ? 0 : 420);
      });
    }
    next();
  }

  /* ── haversine ── */
  function haversine(lat1, lng1, lat2, lng2) {
    var R = 3959, dLat = (lat2-lat1)*Math.PI/180, dLng = (lng2-lng1)*Math.PI/180;
    var a = Math.sin(dLat/2)*Math.sin(dLat/2) +
      Math.cos(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*Math.sin(dLng/2)*Math.sin(dLng/2);
    return 2*R*Math.asin(Math.sqrt(a));
  }

  /* ── leaflet loader ── */
  var leafletReady = false, leafletCallbacks = [];
  function loadLeaflet(done) {
    if (leafletReady) { done(); return; }
    leafletCallbacks.push(done);
    if (leafletCallbacks.length > 1) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet'; link.href = LEAFLET_CSS;
    document.head.appendChild(link);
    var s = document.createElement('script');
    s.src = LEAFLET_JS;
    s.onload = function() {
      leafletReady = true;
      leafletCallbacks.forEach(function(fn){ fn(); });
      leafletCallbacks = [];
    };
    document.head.appendChild(s);
  }

  /* ── section init ── */
  function initSection(id) {
    var NEARBY_COUNT = 8;
    var inp       = document.getElementById('jjfas-input-'+id);
    var searchBtn = document.getElementById('jjfas-search-btn-'+id);
    var nearby    = document.getElementById('jjfas-nearby-'+id);
    var showAll   = document.getElementById('jjfas-showall-'+id);
    var listTitle = document.getElementById('jjfas-list-title-'+id);
    var storesEl  = document.getElementById('jjfas-stores-'+id);
    var mapEl     = document.getElementById('jjfas-map-'+id);
    var mapLoading = document.getElementById('jjfas-map-loading-'+id);
    if (!storesEl) return;
    if (storesEl.dataset.init) return;
    storesEl.dataset.init = '1';

    var cards   = Array.from(storesEl.querySelectorAll('.jjfas-store'));
    var addrs   = cards.map(function(c){ return c.dataset.addr || ''; });
    var names   = cards.map(function(c){ return c.dataset.name || ''; });
    var gmapsLinks = cards.map(function(c){
      var a = c.querySelector('.jjfas-dir'); return a ? a.href : '';
    });
    var storeCoords = cards.map(function(c){
      var la = parseFloat(c.dataset.lat), ln = parseFloat(c.dataset.lng);
      return (isFinite(la) && isFinite(ln)) ? { lat: la, lng: ln } : null;
    });
    var leafletMap  = null;
    var markers     = [];
    var mapBounds   = [];
    var userMarker  = null;
    var origTitle   = listTitle ? listTitle.textContent : '';

    /* build map marker popup */
    function popupHtml(i) {
      return '<div class="jjfas-popup"><b>' + names[i] + '</b>' +
        (addrs[i] ? '<br><span style="color:#6a5a82;font-size:13px">' + addrs[i] + '</span>' : '') +
        '<br><a href="' + gmapsLinks[i] + '" target="_blank" rel="noopener" ' +
        'style="color:#8a23b8;font-weight:600;font-size:13px;text-decoration:none">Directions →</a></div>';
    }

    /* initialise leaflet map (called after L is loaded) */
    function setupMap() {
      if (!mapEl || leafletMap) return;
      leafletMap = L.map(mapEl, { scrollWheelZoom: false });
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors'
      }).addTo(leafletMap);
      leafletMap.setView([39.5, -98.35], 4);
      /* add any coords already resolved */
      storeCoords.forEach(function(pos, i){ if (pos) addMarker(i, pos); });
    }

    function addMarker(i, pos) {
      if (!leafletMap) return;
      var m = L.marker([pos.lat, pos.lng]).bindPopup(popupHtml(i));
      m.addTo(leafletMap);
      markers[i] = m;
      mapBounds.push([pos.lat, pos.lng]);
      if (mapBounds.length === 1) leafletMap.setView([pos.lat, pos.lng], 10);
      else leafletMap.fitBounds(mapBounds, { padding: [40, 40] });
    }

    /* geocode all stores + build map */
    if (mapEl) {
      loadLeaflet(function(){
        setupMap();
        /* only geocode stores without baked-in coordinates */
        var todo = [];
        addrs.forEach(function(a, i){ if (!storeCoords[i] && a) todo.push(i); });
        if (!todo.length) {
          if (mapLoading) mapLoading.classList.add('done');
          return;
        }
        geocodeSequential(todo.map(function(i){ return addrs[i]; }),
          function onEach(k, pos) {
            var i = todo[k];
            storeCoords[i] = pos;
            if (pos) addMarker(i, pos);
          },
          function onDone() {
            if (mapLoading) mapLoading.classList.add('done');
          }
        );
      });
    }

    /* show the N closest stores in the list and zoom the map to them */
    function sortByDist(ulat, ulng) {
      cards.forEach(function(card, i){
        var p = storeCoords[i];
        if (p) {
          var d = haversine(ulat, ulng, p.lat, p.lng);
          card._dist = d;
          card.querySelector('.jjfas-store-dist').textContent =
            (d < 10 ? d.toFixed(1) : Math.round(d)) + ' mi away';
        } else {
          card._dist = Infinity;
        }
      });
      var sorted  = cards.slice().sort(function(a,b){ return (a._dist||Infinity)-(b._dist||Infinity); });
      var nearest = sorted.filter(function(c){ return c._dist !== Infinity; }).slice(0, NEARBY_COUNT);
      sorted.forEach(function(c){
        c.style.display = nearest.indexOf(c) === -1 ? 'none' : '';
        storesEl.appendChild(c);
      });
      if (leafletMap) {
        var bounds = [];
        cards.forEach(function(card, i){
          var m = markers[i], p = storeCoords[i];
          if (!m || !p) return;
          if (nearest.indexOf(card) === -1) {
            if (leafletMap.hasLayer(m)) leafletMap.removeLayer(m);
          } else {
            if (!leafletMap.hasLayer(m)) m.addTo(leafletMap);
            bounds.push([p.lat, p.lng]);
          }
        });
        if (userMarker) leafletMap.removeLayer(userMarker);
        userMarker = L.circleMarker([ulat, ulng], {
          radius: 8, color: '#fff', weight: 2, fillColor: '#8a23b8', fillOpacity: 1
        }).bindPopup('Your location');
        userMarker.addTo(leafletMap);
        bounds.push([ulat, ulng]);
        leafletMap.fitBounds(bounds, { padding: [40, 40], maxZoom: 11 });
      }
      if (listTitle) listTitle.textContent = 'The ' + nearest.length + ' closest stores';
      if (showAll) showAll.hidden = false;
    }

    /* reset to the full list and nationwide map */
    function showAllStores() {
      cards.forEach(function(c){
        c.style.display = '';
        c.querySelector('.jjfas-store-dist').textContent = '';
        storesEl.appendChild(c);
      });
      if (leafletMap) {
        var bounds = [];
        cards.forEach(function(c, i){
          var m = markers[i], p = storeCoords[i];
          if (m && p) {
            if (!leafletMap.hasLayer(m)) m.addTo(leafletMap);
            bounds.push([p.lat, p.lng]);
          }
        });
        if (userMarker) { leafletMap.removeLayer(userMarker); userMarker = null; }
        if (bounds.length) leafletMap.fitBounds(bounds, { padding: [40, 40] });
      }
      if (listTitle) listTitle.textContent = origTitle;
      if (showAll) showAll.hidden = true;
    }
    if (showAll) showAll.addEventListener('click', showAllStores);

    function setBtnLabel(t) { if (searchBtn) searchBtn.textContent = t; }

    function searchLocation(ulat, ulng) {
      /* if store geocoding is still in progress, wait */
      var pending = storeCoords.filter(function(p, i){ return !p && addrs[i]; }).length;
      if (pending > 0) {
        setBtnLabel('Finishing up…');
        var poll = setInterval(function(){
          var still = storeCoords.filter(function(p, i){ return !p && addrs[i]; }).length;
          if (still === 0) { clearInterval(poll); sortByDist(ulat, ulng); setBtnLabel('Find stores'); }
        }, 200);
      } else {
        sortByDist(ulat, ulng);
        setBtnLabel('Find stores');
      }
    }

    /* search button */
    if (searchBtn && inp) {
      searchBtn.addEventListener('click', function(){
        var q = inp.value.trim(); if (!q) return;
        setBtnLabel('Searching…');
        geocode(q, function(pos){
          if (!pos) {
            setBtnLabel('Location not found');
            setTimeout(function(){ setBtnLabel('Find stores'); }, 2500);
            return;
          }
          searchLocation(pos.lat, pos.lng);
        });
      });
      inp.addEventListener('keydown', function(e){ if (e.key === 'Enter') searchBtn.click(); });
    }

    /* use my location */
    if (nearby) {
      nearby.addEventListener('click', function(){
        if (!navigator.geolocation) { nearby.textContent = 'Not available'; return; }
        nearby.textContent = 'Locating…'; nearby.disabled = true;
        navigator.geolocation.getCurrentPosition(
          function(pos){
            nearby.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/></svg> Use my location';
            nearby.disabled = false;
            searchLocation(pos.coords.latitude, pos.coords.longitude);
          },
          function(){
            nearby.textContent = 'Could not get location'; nearby.disabled = false;
            setTimeout(function(){
              nearby.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/></svg> Use my location';
            }, 2500);
          },
          { timeout: 8000 }
        );
      });
    }
  }

  function initAll(){
    document.querySelectorAll('.jjfas').forEach(function(el){
      initSection(el.id.replace('jjfas-',''));
    });
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('.jjfas'); if (el) initSection(el.id.replace('jjfas-',''));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.jjHeroInit) return;
    root.dataset.jjHeroInit='1';
    var video=root.querySelector('.jjhero-video');
    if(!video) return;
    var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if(reduce){ video.style.display='none'; return; }
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          video.play().then(function(){ video.classList.add('is-playing'); }).catch(function(){});
        } else {
          video.pause();
        }
      });
    },{threshold:0.1});
    obs.observe(root);
    video.addEventListener('error',function(){ video.style.display='none'; });
  }
  function initAll(){ document.querySelectorAll('.jjhero').forEach(init); }
  if(document.readyState!=='loading') initAll();
  else document.addEventListener('DOMContentLoaded',initAll);
  document.addEventListener('shopify:section:load',function(e){
    var el=e.target.querySelector('.jjhero'); if(el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-in-the-wild"] && !Shopify.designMode) return;
  try {
    
(function(){
  var JEWEL=[[124,58,214],[40,120,232],[20,178,150],[196,46,168],[236,150,40],[240,92,74],[240,84,138],[246,188,36]];
  var SHAPES=["50%","50% / 40%","62% 38% 42% 58% / 55% 60% 40% 45%","0 50% 0 50% / 50%","50% 50% 50% 12%","42% 58% 53% 47% / 58% 42% 58% 42%","50% 50% 46% 46% / 60% 60% 40% 40%","58% 42% 45% 55% / 48% 52% 48% 52%"];

  function rng(s){return function(){s|=0;s=s+0x6D2B79F5|0;var t=Math.imul(s^s>>>15,1|s);t=t+Math.imul(t^t>>>7,61|t)^t;return((t^t>>>14)>>>0)/4294967296}}

  function initSection(id){
    var root=document.getElementById('jjitw-'+id);
    if(!root||root.dataset.jjitwInit)return;
    root.dataset.jjitwInit='1';

    var panel=document.getElementById('jjitw-panel-'+id);
    var field=document.getElementById('jjitw-field-'+id);
    var sun=document.getElementById('jjitw-sun-'+id);
    var dawn=document.getElementById('jjitw-dawn-'+id);
    var fadeEls=root.querySelectorAll('.jjitw-in');
    var r=rng(7240622),cells=[];

    function C(i){return JEWEL[i%JEWEL.length]}

    function addCell(o){
      var el=document.createElement('div');
      el.className='jjitw-cell jjitw-'+o.cls+(o.spark?' jjitw-spark':'');
      var col=o.c,R=col[0],G=col[1],B=col[2];
      el.style.left=o.x+'%'; el.style.top=o.y+'%';
      el.style.width=o.s+'px'; el.style.height=o.s+'px';
      el.style.setProperty('--core','rgba('+R+','+G+','+B+','+o.core+')');
      el.style.setProperty('--rim','rgba('+R+','+G+','+B+','+o.rim+')');
      el.style.setProperty('--e','rgba('+R+','+G+','+B+',.18)');
      el.style.setProperty('--bd',o.bd);
      el.style.setProperty('--rad',o.rad);
      if(o.bl)el.style.setProperty('--bl',o.bl+'px');
      el.style.setProperty('--fx',((r()*2-1)*92).toFixed(0)+'px');
      el.style.setProperty('--fy',((r()*2-1)*92).toFixed(0)+'px');
      el.style.setProperty('--r0',((r()*2-1)*36).toFixed(0)+'deg');
      el.style.setProperty('--rx',((r()*2-1)*8).toFixed(1)+'deg');
      el.innerHTML='<span class="jjitw-fill"></span><span class="jjitw-glint"></span>';
      field.appendChild(el); cells.push(el);
    }

    /* washes — soft ambient color, no border */
    for(var i=0;i<8;i++){
      var ex=r()<.5?r()*22:78+r()*22;
      addCell({cls:'wash',x:ex,y:6+r()*88,s:150+r()*150,core:.42,rim:.22,bd:'0',
        c:C(Math.floor(r()*8)),rad:SHAPES[2+Math.floor(r()*4)],bl:(6+r()*8).toFixed(0)});
    }
    /* medium jewels — saturated, visible edge */
    for(var i=0;i<17;i++){
      addCell({cls:'med',x:3+r()*94,y:5+r()*90,s:64+r()*78,core:.76,rim:.32,bd:'1.8px',
        c:C(Math.floor(r()*8)),rad:SHAPES[Math.floor(r()*SHAPES.length)]});
    }
    /* small accents */
    for(var i=0;i<28;i++){
      addCell({cls:'sm',x:2+r()*96,y:4+r()*92,s:20+r()*42,core:.80,rim:.36,bd:'1.3px',
        c:C(Math.floor(r()*8)),rad:SHAPES[Math.floor(r()*SHAPES.length)],spark:r()>.78});
    }

    var order=cells.map(function(_,i){return i}).sort(function(){return r()-.5});
    order.forEach(function(idx,pos){cells[idx]._order=pos});

    var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
    var counted=false;

    function runCounters(){
      if(counted)return; counted=true;
      root.querySelectorAll('.jjitw-num').forEach(function(el){
        var to=+el.dataset.to,suf=el.dataset.suf||'',t0=performance.now(),dur=1000;
        (function step(n){
          var p=Math.min((n-t0)/dur,1),e=1-Math.pow(1-p,3);
          el.textContent=Math.round(to*e)+suf;
          if(p<1)requestAnimationFrame(step);
        })(performance.now());
      });
    }

    function setLit(sp){
      sun.style.opacity=sp.toFixed(2);
      sun.style.transform='translate(-50%,'+(62-70*sp).toFixed(0)+'%) scale('+(0.85+0.28*sp).toFixed(2)+')';
      dawn.style.opacity=(sp*0.85).toFixed(2);
      field.style.filter='brightness('+(1+0.24*sp).toFixed(2)+') saturate('+(1+0.4*sp).toFixed(2)+')';
    }

    if(reduce){
      cells.forEach(function(c){c.classList.add('in')});
      fadeEls.forEach(function(el){el.classList.add('show')});
      runCounters(); setLit(1); return;
    }

    var ticking=false;
    function update(){
      ticking=false;
      var rect=panel.getBoundingClientRect(),vh=innerHeight;
      var p=Math.max(0,Math.min(1,(vh*0.92-rect.top)/(vh*0.9)));

      var revealed=Math.round(Math.min(p/0.62,1)*cells.length);
      cells.forEach(function(c){c.classList.toggle('in',c._order<revealed)});

      setLit(Math.max(0,Math.min((p-0.5)/0.48,1)));

      fadeEls.forEach(function(el){
        el.classList.toggle('show',p>=parseFloat(el.dataset.p||'0.14'));
      });

      if(p>=0.33)runCounters();
    }

    addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(update);}},{passive:true});
    addEventListener('resize',update);
    update();
  }

  function initAll(){
    document.querySelectorAll('.jjitw').forEach(function(el){
      initSection(el.id.replace('jjitw-',''));
    });
  }

  if(document.readyState!=='loading')initAll();
  else document.addEventListener('DOMContentLoaded',initAll);
  document.addEventListener('shopify:section:load',function(e){
    var el=e.target.querySelector('.jjitw');
    if(el)initSection(el.id.replace('jjitw-',''));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-product-accessories"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.jjAccInit) return;
    root.dataset.jjAccInit='1';
    if(root.dataset.revealOnAtc!=='true') return;

    /* hide initially; reveal when add-to-cart fires on the SAME product page */
    root.style.display='none';

    function reveal(){
      root.style.display='';
      root.style.opacity='0';
      requestAnimationFrame(function(){
        root.style.transition='opacity .5s ease';
        root.style.opacity='1';
        setTimeout(function(){
          root.scrollIntoView({behavior:'smooth',block:'nearest'});
        },200);
      });
    }

    /* Shopify AJAX add-to-cart emits this event on the window */
    document.addEventListener('cart:item-added', reveal, {once:true});

    /* fallback: listen for any product form submit on the page */
    var productForms=document.querySelectorAll('form[action*="/cart/add"]');
    productForms.forEach(function(f){
      f.addEventListener('submit',function(){
        setTimeout(reveal,800);
      },{once:true});
    });
  }

  function initAll(){ document.querySelectorAll('.jjacc').forEach(init); }
  if(document.readyState!=='loading') initAll();
  else document.addEventListener('DOMContentLoaded',initAll);
  document.addEventListener('shopify:section:load',function(e){
    var el=e.target.querySelector('.jjacc'); if(el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-product"] && !Shopify.designMode) return;
  try {
    
(function(){

  function init(section){
    if(section.dataset.jjPdInit) return;
    section.dataset.jjPdInit='1';

    /* ── Gallery ── */
    var stage     = section.querySelector('.jjpd-stage');
    var slides    = Array.from(section.querySelectorAll('.jjpd-stage-img'));
    var thumbs    = Array.from(section.querySelectorAll('.jjpd-thumb'));
    var prevBtn   = section.querySelector('.jjpd-nav--prev');
    var nextBtn   = section.querySelector('.jjpd-nav--next');
    var counter   = section.querySelector('.jjpd-counter-cur');
    var zoomBtn   = section.querySelector('.jjpd-zoom-btn');
    var current   = 0;

    function isVideo(el){
      return el && (el.tagName === 'VIDEO' || el.dataset.mediaType === 'external_video');
    }

    function showImg(idx){
      if(!slides.length) return;
      idx = ((idx % slides.length) + slides.length) % slides.length;

      slides.forEach(function(slide, i){
        var active = i === idx;
        slide.classList.toggle('is-active', active);
        /* hosted video: play when active, pause when not */
        if(slide.tagName === 'VIDEO'){
          if(active){ slide.play && slide.play().catch(function(){}); }
          else       { slide.pause && slide.pause(); }
        }
      });

      thumbs.forEach(function(th, i){
        th.classList.toggle('is-active', i===idx);
        th.setAttribute('aria-pressed', i===idx ? 'true':'false');
        if(i===idx) th.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
      });

      if(counter) counter.textContent = idx+1;
      /* hide zoom button on video slides */
      if(zoomBtn) zoomBtn.style.display = isVideo(slides[idx]) ? 'none' : '';
      current = idx;
    }

    /* external video play button — opens in existing demo dialog */
    slides.forEach(function(slide){
      if(slide.dataset.mediaType !== 'external_video') return;
      var playBtn = slide.querySelector('.jjpd-extv-play');
      if(!playBtn) return;
      playBtn.addEventListener('click', function(){
        var sectionIdRaw = section.id.replace('jjpd-','');
        var vDialog = document.getElementById('jjpd-vdialog-'+sectionIdRaw);
        var vPlayer = vDialog ? vDialog.querySelector('.jjpd-vd-player') : null;
        var vClose  = vDialog ? vDialog.querySelector('.jjpd-vd-close') : null;
        if(!vDialog || !vPlayer) return;
        var embedBase = slide.dataset.host === 'youtube'
          ? 'https://www.youtube.com/embed/'
          : 'https://player.vimeo.com/video/';
        vPlayer.innerHTML = '<iframe src="' + embedBase + slide.dataset.extId + '?autoplay=1&rel=0" allow="autoplay; fullscreen" allowfullscreen title="Product video"></iframe>';
        vDialog.showModal();
        if(vClose) vClose.focus();
      });
    });

    thumbs.forEach(function(th,i){
      th.addEventListener('click', function(){ showImg(i); });
    });
    if(prevBtn) prevBtn.addEventListener('click', function(){ showImg(current-1); });
    if(nextBtn) nextBtn.addEventListener('click', function(){ showImg(current+1); });

    /* keyboard nav on stage */
    if(stage){
      stage.addEventListener('keydown', function(e){
        if(e.key==='ArrowLeft'||e.key==='ArrowUp')   { e.preventDefault(); showImg(current-1); }
        if(e.key==='ArrowRight'||e.key==='ArrowDown') { e.preventDefault(); showImg(current+1); }
      });

      /* touch swipe */
      var touchX = 0;
      stage.addEventListener('touchstart', function(e){ touchX = e.changedTouches[0].screenX; }, {passive:true});
      stage.addEventListener('touchend', function(e){
        var delta = e.changedTouches[0].screenX - touchX;
        if(Math.abs(delta) > 40){ showImg(delta < 0 ? current+1 : current-1); }
      });
    }

    showImg(0);

    /* ── Zoom modal ── */
    var zoomModal = document.getElementById('jjpd-zoom-'+section.id.replace('jjpd-',''));
    var zoomImg   = zoomModal ? zoomModal.querySelector('.jjpd-zoom-img') : null;
    var zoomClose = zoomModal ? zoomModal.querySelector('.jjpd-zoom-close') : null;

    function openZoom(){
      var active = section.querySelector('.jjpd-stage-img.is-active');
      /* don't zoom videos */
      if(!active || !zoomModal || isVideo(active)) return;
      zoomImg.src = active.currentSrc || active.src;
      zoomImg.alt = active.alt;
      zoomModal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      zoomClose.focus();
    }
    function closeZoom(){
      if(!zoomModal) return;
      zoomModal.classList.remove('is-open');
      document.body.style.overflow = '';
      if(zoomBtn) zoomBtn.focus();
    }
    if(zoomBtn) zoomBtn.addEventListener('click', openZoom);
    if(stage)   stage.addEventListener('click',   function(e){ if(e.target===e.currentTarget||e.target.classList.contains('jjpd-stage-img')) openZoom(); });
    if(zoomClose) zoomClose.addEventListener('click', closeZoom);
    if(zoomModal) zoomModal.addEventListener('click', function(e){ if(e.target===zoomModal) closeZoom(); });

    document.addEventListener('keydown', function(e){
      if(e.key==='Escape' && zoomModal && !zoomModal.hidden) closeZoom();
    });

    /* ── Quantity buttons ── */
    var qtyInput = section.querySelector('.jjpd-qty-input');
    section.querySelectorAll('.jjpd-qty-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        if(!qtyInput) return;
        var v = parseInt(qtyInput.value,10)||1;
        if(btn.dataset.action==='plus')            qtyInput.value = v+1;
        if(btn.dataset.action==='minus' && v > 1) qtyInput.value = v-1;
      });
    });

    /* ── Sticky mobile ATC bar ── */
    var atcBtn    = section.querySelector('.jjpd-atc');
    var stickyBar = section.nextElementSibling; /* sticky bar is next sibling of jjpd */
    /* scan for the sticky bar by ID more reliably */
    var sectionId = section.id.replace('jjpd-','');
    var stickyBarEl = document.getElementById('jjpd-sticky-'+sectionId);

    if(atcBtn && stickyBarEl){
      /* only activate on mobile */
      var mq = window.matchMedia('(max-width: 859px)');
      function handleMQ(){
        if(mq.matches){
          stickyBarEl.style.display='block';
          var obs = new IntersectionObserver(function(entries){
            entries.forEach(function(e){
              stickyBarEl.classList.toggle('is-visible', !e.isIntersecting);
              stickyBarEl.setAttribute('aria-hidden', e.isIntersecting ? 'true':'false');
            });
          },{threshold:0});
          obs.observe(atcBtn);
        } else {
          stickyBarEl.style.display='none';
          stickyBarEl.classList.remove('is-visible');
        }
      }
      handleMQ();
      mq.addEventListener('change', handleMQ);

      /* wire sticky ATC to main form */
      var stickyAtc = stickyBarEl.querySelector('.jjpd-sticky-atc');
      if(stickyAtc){
        stickyAtc.addEventListener('click', function(){
          var form = atcBtn.closest('form');
          if(form) form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }
    }

    /* ── Sync price on variant change ── */
    var variantSel    = section.querySelector('.jjpd-variant-select');
    var priceEl       = section.querySelector('.jjpd-price');
    var compareEl     = section.querySelector('.jjpd-compare');
    var saveBadgeEl   = section.querySelector('.jjpd-save-badge');
    var atcPriceEl    = section.querySelector('.jjpd-atc-price');
    var stickyPriceEl = stickyBarEl ? stickyBarEl.querySelector('.jjpd-sticky-price') : null;
    var sectionIdRaw  = section.id.replace('jjpd-','');
    var variantDataEl = document.getElementById('jjpd-variants-'+sectionIdRaw);
    var variantMap    = {};

    if(variantDataEl){
      try{
        var parsed = JSON.parse(variantDataEl.textContent);
        parsed.forEach(function(v){ variantMap[v.id] = v; });
      }catch(e){}
    }

    function fmtMoney(cents){
      return '$' + (cents/100).toFixed(2);
    }

    if(variantSel && priceEl){
      variantSel.addEventListener('change', function(){
        var v = variantMap[parseInt(variantSel.value, 10)];
        if(!v) return;

        var price   = fmtMoney(v.price);
        var compare = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : null;

        priceEl.textContent = price;
        if(atcPriceEl)    atcPriceEl.textContent    = price;
        if(stickyPriceEl) stickyPriceEl.textContent = price;

        /* compare-at price + save badge */
        if(compare){
          if(compareEl)   { compareEl.textContent = fmtMoney(compare); compareEl.style.display=''; }
          if(saveBadgeEl) { saveBadgeEl.textContent = 'Save '+fmtMoney(compare - v.price); saveBadgeEl.style.display=''; }
        } else {
          if(compareEl)   compareEl.style.display   = 'none';
          if(saveBadgeEl) saveBadgeEl.style.display = 'none';
        }

        /* sold-out state */
        var atc = section.querySelector('.jjpd-atc');
        if(atc) atc.disabled = !v.available;
      });
    }

    /* ── Demo video dialog ── */
    var demoBtn   = section.querySelector('.jjpd-demo-btn');
    var sectionId = section.id.replace('jjpd-','');
    var vDialog   = document.getElementById('jjpd-vdialog-'+sectionId);
    var vPlayer   = vDialog ? vDialog.querySelector('.jjpd-vd-player') : null;
    var vClose    = vDialog ? vDialog.querySelector('.jjpd-vd-close') : null;

    function openDemoVideo(){
      if(!demoBtn||!vDialog) return;
      vPlayer.innerHTML='<iframe src="https://www.youtube.com/embed/'+demoBtn.dataset.ytid+'?autoplay=1&rel=0" allow="autoplay; fullscreen" allowfullscreen title="'+demoBtn.dataset.title+'"></iframe>';
      vDialog.showModal();
      if(vClose) vClose.focus();
    }
    function closeDemoVideo(){
      if(!vDialog) return;
      vDialog.close();
      if(vPlayer) vPlayer.innerHTML='';
    }
    if(demoBtn)  demoBtn.addEventListener('click', openDemoVideo);
    if(vClose)   vClose.addEventListener('click', closeDemoVideo);
    if(vDialog){
      vDialog.addEventListener('click', function(e){ if(e.target===vDialog) closeDemoVideo(); });
      vDialog.addEventListener('cancel', closeDemoVideo);
    }
  }

  function initAll(){
    document.querySelectorAll('[id^="jjpd-"]').forEach(function(el){
      if(el.classList.contains('jjpd')) init(el);
    });
  }

  if(document.readyState!=='loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('.jjpd');
    if(el) init(el);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-why-joyjems"] && !Shopify.designMode) return;
  try {
    
(function(){
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('show'); io.unobserve(e.target); }
    });
  },{threshold:0.12});
  document.querySelectorAll('.jjwhy-reveal').forEach(function(el){ io.observe(el); });
  document.addEventListener('shopify:section:load', function(e){
    e.target.querySelectorAll('.jjwhy-reveal').forEach(function(el){ el.classList.add('show'); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mood-sorter"] && !Shopify.designMode) return;
  try {
    
(function(){
  function cap(s){return s.charAt(0).toUpperCase()+s.slice(1);}
  function init(root){
    if(root.dataset.msInit) return; root.dataset.msInit="1";
    var grid=root.querySelector(".jjms-grid");
    var sub=root.querySelector(".jjms-sub");
    var cards=Array.prototype.slice.call(root.querySelectorAll(".jjms-card"));
    if(!grid||!cards.length) return;
    var featured=parseInt(root.dataset.featured,10)||2;

    function ordered(mode){
      return cards.slice().sort(function(a,b){
        var d=(+b.dataset[mode])-(+a.dataset[mode]);
        return d!==0?d:(+a.dataset.idx)-(+b.dataset.idx);
      });
    }
    function apply(mode,instant){
      var reduce=window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var first=cards.map(function(c){return c.getBoundingClientRect();});
      root.classList.remove("m-calm","m-bright","m-wow");
      root.classList.add("m-"+mode);
      root.querySelectorAll(".jjms-mode").forEach(function(b){
        b.setAttribute("aria-pressed", b.dataset.mode===mode ? "true":"false");
      });
      if(sub){ sub.textContent=sub.dataset[mode]||""; sub.classList.add("show"); }
      var ord=ordered(mode);
      ord.forEach(function(c){ grid.appendChild(c); });
      cards.forEach(function(c){
        c.classList.remove("feat","feat-top");
        var w=c.querySelector(".jjms-why"); w.textContent=""; w.hidden=true;
      });
      ord.slice(0,featured).forEach(function(c,i){
        c.classList.add("feat");
        if(i===0) c.classList.add("feat-top");
        var t=c.dataset["why"+cap(mode)]||"";
        var w=c.querySelector(".jjms-why");
        if(t){ w.textContent=t; w.hidden=false; }
      });
      if(instant||reduce) return;
      cards.forEach(function(c,i){
        var f=first[i], l=c.getBoundingClientRect();
        var dx=f.left-l.left, dy=f.top-l.top;
        var sx=l.width?f.width/l.width:1, sy=l.height?f.height/l.height:1;
        var inn=c.querySelector(".jjms-card-in");
        c.style.transition="none"; inn.style.transition="none";
        c.style.transformOrigin="top left"; inn.style.transformOrigin="top left";
        c.style.transform="translate("+dx+"px,"+dy+"px) scale("+sx+","+sy+")";
        inn.style.transform="scale("+(1/sx)+","+(1/sy)+")";
      });
      requestAnimationFrame(function(){requestAnimationFrame(function(){
        cards.forEach(function(c){
          var inn=c.querySelector(".jjms-card-in");
          c.style.transition="transform .6s cubic-bezier(.2,.85,.25,1)";
          inn.style.transition="transform .6s cubic-bezier(.2,.85,.25,1)";
          c.style.transform=""; inn.style.transform="";
        });
      });});
    }
    root.querySelectorAll(".jjms-mode").forEach(function(b){
      b.addEventListener("click", function(){ apply(b.dataset.mode); });
    });
    var def=root.dataset.default;
    if(def && def!=="none") apply(def, true);
  }
  function initAll(){ document.querySelectorAll(".jjms").forEach(init); }
  if(document.readyState!=="loading") initAll();
  else document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", function(e){
    var r=e.target.querySelector&&e.target.querySelector(".jjms"); if(r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
